<template>
  <Header></Header>
  <div><el-image :src="contact_dt"></el-image></div>
  <Footer></Footer>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "Contact",
  data() {
    return {
      contact_dt: "https://nicedream.top:8202/gw_lmm/info1.jpg",
    };
  },
  components: { Header, Footer },
};
</script>

<style scoped>
</style>